export var buildKeyFromStrings = function buildKeyFromStrings() {
  for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
    strings[_key] = arguments[_key];
  }

  return strings.map(function () {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return string.toString();
  }).join('');
};